import styled from "styled-components";

export const ContainerFilaVirtual = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: transparent;
`;

export const FilaVirtualTitulo = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 40px;
`;

export const FilaVirtualIcono = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 52px;
  text-align: center;
`;
export const FilaVirtualTxt = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 52px;
  text-align: center;
`;
export const FilaVirtualConoceMasTxt = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 104px;
  text-align: center;
  .FilaVirtualConoceMasTxt {
    text-decoration: underline;
    cursor: pointer;
  }
`;
export const FilaVirtualBotones = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 52px;
  text-align: center;
`;
